const NEWS_MEDIA_MACRO_SPLIT_RE =
  /(?:<p>\s*)?\{\{media:(\d+)\}\}(?:\s*<\/p>)?/gi

export type NewsContentSegment =
  | { type: 'html'; html: string }
  | { type: 'media'; slot: number }

const isEmptyHtml = (html: string) =>
  html.replaceAll(/<[^>]+>/g, '').replaceAll(/\s+/g, '').length === 0

export function parseNewsContent(content?: string): NewsContentSegment[] {
  if (!content?.trim()) {
    return []
  }

  const segments: NewsContentSegment[] = []
  let lastIndex = 0

  for (const match of content.matchAll(NEWS_MEDIA_MACRO_SPLIT_RE)) {
    const index = match.index
    if (index === undefined) {
      continue
    }

    const htmlBefore = content.slice(lastIndex, index)
    if (!isEmptyHtml(htmlBefore)) {
      segments.push({ type: 'html', html: htmlBefore })
    }

    segments.push({ type: 'media', slot: Number(match[1]) })
    lastIndex = index + match[0].length
  }

  const htmlAfter = content.slice(lastIndex)
  if (!isEmptyHtml(htmlAfter)) {
    segments.push({ type: 'html', html: htmlAfter })
  }

  if (segments.length === 0 && !isEmptyHtml(content)) {
    segments.push({ type: 'html', html: content })
  }

  return segments
}
